import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button, Close3Icon } from '@blade/ui-kit'
import { Platform } from '@root/entities/platform'
import { Gear2Icon } from '@root/shared/ui-kit'
import { HeaderBrand } from '@root/widgets/header/ui/header-brand'
import { NotificationWidgets } from '@root/widgets/notification-widgets'

import { notificationCenterScreenAtom } from '../../atoms'

import { NotificationCenterPlatforms } from './notification-center-platforms'
import { NotificationCenterUpdates } from './notification-center-updates'

type Props = {
  value: Platform.Platform
  onChange: (platform: Platform.Platform) => void
  onClose: () => void
}

export const NotificationCenterBody: React.FC<Props> = ({
  value = Platform.Terminal,
  onChange,
  onClose,
}) => {
  const { t } = useTranslation()
  const [_, setScreen] = useAtom(notificationCenterScreenAtom)

  const handleScreenChange = () => {
    setScreen('edit')
  }

  return (
    <Root>
      <Header>
        <HeaderBrand />
        <Button
          variant="ghost"
          size="h28"
          iconLeft={<Gear2Icon />}
          radius="rounded"
          onClick={handleScreenChange}
        >
          {t('notification-center.set_widgets')}
        </Button>
        <CloseButton variant="soft" size="xxs" onClick={onClose}>
          <Close3Icon size={12} />
        </CloseButton>
      </Header>
      <NotificationWidgets />
      <NotificationCenterUpdates />
      <NotificationCenterPlatforms value={value} onChange={onChange} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  gap: 10px;
  padding: 12px;
  background: var(--background-1);
  height: 100%;

  align-items: start;
  align-content: start;
`

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  align-items: center;
  justify-content: start;
  justify-items: start;

  gap: 8px;
`

const CloseButton = styled(Button)`
  background: var(--backgroundA-1);

  height: 30px;
  width: 30px;
  padding: 0;
`
